import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b999ce4")

_pushScopeId("data-v-4b999ce4")
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = { class: "module top" }
const _hoisted_3 = { class: "core-wrap" }
const _hoisted_4 = { class: "top-module-item" }
const _hoisted_5 = { class: "core" }
const _hoisted_6 = { class: "core-sun" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#delivery-a-Totalnumberofsynchronizationentries" })
], -1)
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "title" }, "累计同步订单", -1)
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "top-module-item" }
const _hoisted_12 = { class: "core" }
const _hoisted_13 = { class: "core-sun" }
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#delivery-a-Cumulativesynchronousorder" })
], -1)
const _hoisted_15 = { class: "text" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "title" }, "累计同步条数", -1)
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "module-wrap" }
const _hoisted_19 = { class: "module left" }
const _hoisted_20 = { class: "module-hrader" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h5", null, "发货排名", -1)
const _hoisted_22 = { class: "table-box" }
const _hoisted_23 = { class: "module right" }
const _hoisted_24 = { class: "module-hrader" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h5", null, "使用趋势", -1)
const _hoisted_26 = { class: "charts-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Table = _resolveComponent("Table")
  const _component_Charts = _resolveComponent("Charts")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Skeleton, {
            loading: _ctx.panelLoading,
            type: "panel",
            style: {"width":"194px"}
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.topData?.tracked_order_count) + " 单", 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_Skeleton, {
            loading: _ctx.panelLoading,
            type: "panel",
            style: {"width":"194px"}
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("div", _hoisted_17, _toDisplayString(_ctx.topData?.tracked_carrier_count) + " 条", 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_18, [
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_el_select, {
            modelValue: _ctx.detailsSelect,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailsSelect = $event)),
            size: "small",
            style: {"width":"120px"},
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSel('detail')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Table, {
            data: _ctx.tableConf.list,
            loading: _ctx.tableConf.loading,
            height: "400"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, {
                label: "物流名称",
                prop: "courier_name"
              }),
              _createVNode(_component_el_table_column, {
                label: "发货次数",
                prop: "tracked_carrier_count"
              })
            ]),
            _: 1
          }, 8, ["data", "loading"])
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_el_select, {
            modelValue: _ctx.lineSelectIndex,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.lineSelectIndex = $event)),
            size: "small",
            style: {"width":"120px"},
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSel('line')))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _withDirectives(_createVNode("div", _hoisted_26, [
          (_ctx.chartConf.source)
            ? (_openBlock(), _createBlock(_component_Charts, {
                x: _ctx.chartConf.x,
                tooltipFormatter: _ctx.tooltipFormatter,
                source: _ctx.chartConf.source,
                key: _ctx.chartConf.key
              }, null, 8, ["x", "tooltipFormatter", "source"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_loading, _ctx.chartConf.loading]
        ])
      ])
    ])
  ]))
})